import React from 'react';
import { motion } from 'framer-motion';
const seasons = [{
  name: 'Spring',
  icon: '🌱',
  color: 'bg-green-50 border-green-200',
  textColor: 'text-green-800',
  accent: 'bg-green-500',
  services: 'Sod · Seasonal Flowers · Mulch'
}, {
  name: 'Summer',
  icon: '☀️',
  color: 'bg-yellow-50 border-yellow-200',
  textColor: 'text-yellow-800',
  accent: 'bg-yellow-500',
  services: 'Sprigs · Pressure Washing · Plants'
}, {
  name: 'Fall',
  icon: '🍂',
  color: 'bg-orange-50 border-orange-200',
  textColor: 'text-orange-800',
  accent: 'bg-orange-500',
  services: 'Pavers · Drainage · Cleanup'
}, {
  name: 'Winter',
  icon: '❄️',
  color: 'bg-blue-50 border-blue-200',
  textColor: 'text-blue-800',
  accent: 'bg-blue-500',
  services: 'Planning · Drainage · Consultations'
}];
export function SeasonalCalendar() {
  return <section className="py-24 bg-white" data-id="element-154">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-155">
        <div className="text-center mb-16" data-id="element-156">
          <h2 className="text-sm font-bold tracking-widest text-forest-700 uppercase mb-3" data-id="element-157">
            Year-Round Care
          </h2>
          <h3 className="text-3xl md:text-5xl font-heading font-bold text-earth-900 mb-6" data-id="element-158">
            Service Calendar
          </h3>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-medium" data-id="element-159">
            Your property looks great in every season — not just one.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-160">
          {seasons.map((season, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`rounded-2xl border p-8 relative overflow-hidden ${season.color}`} data-id="element-161">
              <div className={`absolute top-0 left-0 w-full h-1.5 ${season.accent}`} data-id="element-162" />
              <div className="text-4xl mb-4" data-id="element-163">{season.icon}</div>
              <h4 className={`text-2xl font-heading font-bold mb-3 ${season.textColor}`} data-id="element-164">
                {season.name}
              </h4>
              <p className="text-gray-700 font-medium leading-relaxed" data-id="element-165">
                {season.services}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}